import React from "react";
import { useSelector } from "react-redux";
import ErrorComponent from "./components/errorComponent/ErrorComponent";
import MapContainer from "./components/map/MapContainer";
import ResultsList from "./components/results/ResultsList";
import TopBar from "./components/topbar/TopBar";

import { mapSelectors } from "./store/selectors";

const App = () => {
  const singleMarkerResult = useSelector(mapSelectors.getSingleMarkerResult);
  const queryResults = useSelector(mapSelectors.getQueryResults);
  const error = useSelector(mapSelectors.getError);

  return (
    <>
      {error ? (
        <ErrorComponent />
      ) : (
        <>
          <TopBar />
          <MapContainer />
          {(singleMarkerResult || queryResults) && (
            <div className="container">
              <ResultsList
                singleMarkerResult={singleMarkerResult}
                queryResults={queryResults}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default App;
